import { Button } from "@mantine/core";
import { PrivilegeGroup } from "../types/privilege-types";

interface Props {
  rows: PrivilegeGroup[];
  onEdit: (group: PrivilegeGroup) => void;
  onAssign: (group: PrivilegeGroup) => void;
  onDelete: (group: PrivilegeGroup) => void;
}

export default function PrivilegeGroupTable({ rows, onEdit, onAssign, onDelete }: Props) {
  return (
    <div className="overflow-x-auto border rounded-lg">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-100 text-left text-sm font-semibold">
          <tr>
            <th className="px-4 py-3 w-1/3">Tên nhóm quyền</th>
            <th className="px-4 py-3 text-center">Người dùng</th>
            <th className="px-4 py-3 text-center">Trạng thái</th>
            <th className="px-4 py-3 text-right">Hành động</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr>
              <td colSpan={4} className="text-center py-6 text-gray-500">
                Không có nhóm quyền nào
              </td>
            </tr>
          )}
          {rows.map((group) => (
            <tr key={group.id} className="border-t hover:bg-gray-50 transition">
              <td className="px-4 py-3 font-medium">{group.name}</td>
              <td className="px-4 py-3 text-center">{group.user_count}</td>
              <td className="px-4 py-3 text-center">
                {group.status === 1 ? (
                  <span className="text-green-600 font-semibold">Hoạt động</span>
                ) : (
                  <span className="text-gray-400">Tạm ngưng</span>
                )}
              </td>
              <td className="px-4 py-3 text-right space-x-2">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => onEdit(group)}
                >
                  Sửa
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => onAssign(group)}
                >
                  Gán user
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => onDelete(group)}
                >
                  Xóa
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
